module.exports = "/_next/static/images/attorney-asgard-30cd67d110e49ff3340b982a3c32f746.jpg";